import { FormField, FormSelect, RowActionButton } from '@practium/ui';
import type { FertilizerPack } from '@practium/features/api';
import tabStyles from '../Tabs/TabPanel.module.css';
import type { FertilizerPackModalMode } from '../../hooks/useFertilizerPackForm';
import styles from './PlanningPanel.module.css';

interface PlanningPackFieldProps {
	isView: boolean;
	packId: string;
	packLabel: string;
	packOptions: Array<{ value: string; label: string }>;
	selectedPack: FertilizerPack | null;
	error?: string;
	onChange: (value: string) => void;
	onOpenModal: (mode: FertilizerPackModalMode, pack?: FertilizerPack | null) => void;
	onDuplicate: () => void;
	onClear: () => void;
}

export const PlanningPackField = ({
	isView,
	packId,
	packLabel,
	packOptions,
	selectedPack,
	error,
	onChange,
	onOpenModal,
	onDuplicate,
	onClear,
}: PlanningPackFieldProps) => {
	if (isView) {
		return (
			<div className={styles.packRow}>
				<div className={styles.packField}>
					<FormField label="Pacote de produtos" required>
						<span className={tabStyles.viewText}>{packLabel}</span>
					</FormField>
				</div>
			</div>
		);
	}

	return (
		<div className={styles.packRow}>
			<div className={styles.packField}>
				<FormField label="Pacote de produtos" required error={error}>
					<div className={styles.packControl}>
						<div className={styles.packSelect}>
							<FormSelect
								value={packId}
								onChange={onChange}
								options={packOptions}
								placeholder="Selecione o pacote"
								searchable
								clearable
								hasError={!!error}
							/>
						</div>
						<div className={styles.packActions}>
							{packId ? (
								<div className={styles.packActionsExtra}>
									<div className={styles.packActionsExtraInner}>
										<RowActionButton
											variant="edit"
											title="Editar pacote"
											onClick={() => onOpenModal('edit', selectedPack)}
										/>
										<RowActionButton
											variant="duplicate"
											title="Duplicar pacote"
											onClick={onDuplicate}
										/>
										<RowActionButton
											variant="view"
											title="Visualizar pacote"
											onClick={() => onOpenModal('view', selectedPack)}
										/>
										<RowActionButton
											variant="clear"
											title="Limpar pacote"
											onClick={onClear}
										/>
									</div>
								</div>
							) : null}
							<RowActionButton
								variant="add"
								title="Novo pacote"
								onClick={() => onOpenModal('add')}
							/>
						</div>
					</div>
				</FormField>
			</div>
		</div>
	);
};
